import React, { useState } from "react";

export default function IdentificationDetails({ data, onChange }) {
  const [fileName, setFileName] = useState(data?.government_id_proof_img || "");
  const [localData, setLocalData] = useState(data);

  const handleInputChange = (key, value) => {
    const updatedData = { ...localData, [key]: value };
    setLocalData(updatedData);
    onChange(updatedData); // Send all data back as flat structure
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      handleInputChange("government_id_proof_img", file.name); // You can also pass the file itself if needed
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">
        Identification and Social Details
      </h2>
      <div className="grid grid-cols-2 gap-6">
        {/* Government ID Proof */}
        <div>
          <label className="block mb-1">Government ID Proof</label>
          <select
            value={data?.government_id_proof || ""}
            onChange={(e) =>
              handleInputChange("government_id_proof", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value="">Select ID Proof</option>
            <option value="aadhaar">Aadhaar Card</option>
            <option value="pan">PAN Card</option>
            <option value="passport">Passport</option>
            <option value="voter">Voter ID</option>
          </select>
        </div>

        {/* Upload Government ID Proof */}
        <div>
          <label className="block mb-1">Upload Government ID Proof</label>
          <div className="flex items-center gap-2">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
              id="fileUpload"
            />
            <label
              htmlFor="fileUpload"
              className="cursor-pointer px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Choose File
            </label>
            {fileName && <span className="text-gray-600">{fileName}</span>}
          </div>
        </div>

        {/* Social Security/Insurance Number */}
        <div>
          <label className="block mb-1">Social Security/Insurance Number</label>
          <input
            type="text"
            value={data?.social_security_number || ""}
            onChange={(e) =>
              handleInputChange("social_security_number", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Insurance Number"
          />
        </div>

        {/* Caste Category */}
        <div>
          <label className="block mb-1">Caste Category (Optional)</label>
          <select
            value={data?.caste || ""}
            onChange={(e) => handleInputChange("caste", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value="">Select Caste</option>
            <option value="general">General</option>
            <option value="obc">OBC</option>
            <option value="sc">SC</option>
            <option value="st">ST</option>
          </select>
        </div>

        {/* Occupation */}
        <div>
          <label className="block mb-1">Occupation</label>
          <input
            type="text"
            value={data?.occupation || ""}
            onChange={(e) => handleInputChange("occupation", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Occupation"
          />
        </div>

        {/* Family History */}
        <div>
          <label className="block mb-1">Family History</label>
          <textarea
            value={data?.family_history || ""}
            onChange={(e) =>
              handleInputChange("family_history", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Family History"
          ></textarea>
        </div>
      </div>
    </div>
  );
}
